import React from "react";
import { Input, Button, message, Space, Modal } from "antd";

const Captcha = ({ value, onChange, phoneNo, onSendCode, type='REGIST' }) => {
  const [countdown, setCountdown] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [svgData, setSvgData] = React.useState('');
  const [captchaInput, setCaptchaInput] = React.useState('');

  // 倒计时效果
  React.useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown]);

  // 获取图形验证码
  const getSmsSvgData = async () => {
    if (!phoneNo) {
      message.error("请先输入手机号码");
      return;
    }

    // 验证手机号格式
    if (!/^1[3456789]\d{9}$/.test(phoneNo)) {
      message.error("请输入正确的手机号码");
      return;
    }

    try {
      const res = await fetch(`/api/sms/svg?phoneNo=${phoneNo}`);
      const result = await res.json();
      
      if(result && result.success) {
        setSvgData(result.data.svg);
        setIsModalVisible(true);
        setCaptchaInput('');
      } else {
        message.error(result.data);
      }
    } catch (error) {
      message.error("获取验证码失败");
    }
  };

  // 刷新图形验证码
  const refreshCaptcha = async () => {
    if (!phoneNo) return;
    
    try {
      const res = await fetch(`/api/sms/svg?phoneNo=${phoneNo}`);
      const result = await res.json();
      
      if(result && result.success) {
        setSvgData(result.data.svg);
      } else {
        message.error(result.data);
      }
    } catch (error) {
      message.error("刷新验证码失败");
    }
  };

  // 发送短信验证码
  const sendSmsCode = async () => {
    if (!phoneNo || !captchaInput) {
      message.error("请输入图形验证码");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`/api/sms/send-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNo,
          code: captchaInput,
        }),
      });

      const result = await response.json();

      if (result && result.success) {
        message.success("验证码已发送");
        setIsModalVisible(false);
        setCountdown(60); // 设置60秒倒计时
        
        // 如果有外部发送验证码的回调，则执行
        if (onSendCode) {
          onSendCode();
        }
      } else {
        message.error(result.data || "发送失败");
      }
    } catch (error) {
      message.error("发送验证码失败");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (onChange) {
      onChange(value);
    }
  };

  const handleCaptchaInputChange = (e) => {
    setCaptchaInput(e.target.value);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Space direction="horizontal" style={{ width: '100%' }}>
        <Input 
          placeholder="请输入短信验证码" 
          value={value}
          onChange={handleInputChange}
          maxLength={6}
          size="large"
          className="rounded-lg min-h-touch text-base flex-1"
        />
        <Button 
          onClick={getSmsSvgData}
          disabled={countdown > 0 || loading}
          loading={loading}
          size="large"
          className="min-h-touch whitespace-nowrap"
        >
          {countdown > 0 ? `${countdown}秒后重新获取` : "获取验证码"}
        </Button>
      </Space>

      <Modal 
        open={isModalVisible} 
        destroyOnClose={true} 
        onCancel={handleCancel} 
        onOk={sendSmsCode}
        okText="确定"
        cancelText="取消"
      >
        <div 
          style={{ width: '100px', height: '50px'}} 
          dangerouslySetInnerHTML={{ __html: svgData }} 
          onClick={refreshCaptcha} 
        />
        <Input 
          placeholder="请输入上图中的字符" 
          value={captchaInput}
          onChange={handleCaptchaInputChange}
        />
      </Modal>
    </>
  );
};

// 为组件添加符合Ant Design Form规范的属性
Captcha.displayName = 'Captcha';

// 添加符合Ant Design表单控件规范的默认属性
Captcha.defaultProps = {
  value: undefined,
  onChange: () => {},
};

export default Captcha;